export type PricingDialogVariant = 'default' | 'tools' | 'connect'

/**
 * The tools pricing story belongs only to the public /tools funnel.
 *
 * Callers already pass their canonical page path for auth and checkout
 * returns, so use that stable route identity instead of the shared studio's
 * component location. FalToolStudio also renders on /models pages and inside
 * the authenticated product, where the normal pricing copy must remain.
 */
export function pricingDialogVariantForPagePath(
  pagePath: string,
): PricingDialogVariant {
  return pagePath === '/tools' || pagePath.startsWith('/tools/')
    ? 'tools'
    : 'default'
}
